import { render, staticRenderFns } from "./projectsTutorial.vue?vue&type=template&id=01189112&scoped=true"
import script from "./projectsTutorial.vue?vue&type=script&lang=js"
export * from "./projectsTutorial.vue?vue&type=script&lang=js"
import style0 from "./projectsTutorial.vue?vue&type=style&index=0&id=01189112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01189112",
  null
  
)

export default component.exports